import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_scTable = _resolveComponent("scTable");
    const _directive_loading = _resolveDirective("loading");
    return _withDirectives((_openBlock(), _createBlock(_component_scTable, {
        ref: "table",
        data: $data.tableData,
        staticTotal: $data.total,
        height: "470px",
        pageSize: $data.queryInfo.pageSize,
        stripe: "",
        onPaginationChange: $options.paginationChange,
        onPageSizeChange: $options.pageSizeChange,
        "select-on-indeterminate": false
    }, {
        default: _withCtx(()=>[
                _createVNode(_component_el_table_column, {
                    label: "#",
                    width: "55"
                }, {
                    default: _withCtx(({ row })=>[
                            _createVNode(_component_el_radio, {
                                value: `/packageActivity/detail/index?id=${row.id}`,
                                modelValue: $data.id,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.id = $event)
                            }, {
                                default: _withCtx(()=>[
                                        ..._cache[1] || (_cache[1] = [
                                            _createTextVNode("  ", -1)
                                        ])
                                    ]),
                                _: 1
                            }, 8, [
                                "value",
                                "modelValue"
                            ])
                        ]),
                    _: 1
                }),
                _createVNode(_component_el_table_column, {
                    label: "ID",
                    prop: "id",
                    width: "100",
                    align: "center"
                }),
                _createVNode(_component_el_table_column, {
                    label: "活动名称",
                    prop: "name",
                    "min-width": "150",
                    align: "center"
                })
            ]),
        _: 1
    }, 8, [
        "data",
        "staticTotal",
        "pageSize",
        "onPaginationChange",
        "onPageSizeChange"
    ])), [
        [
            _directive_loading,
            $data.isLoading
        ]
    ]);
}
